import { useStoreRoom, useStoreSystem } from "../../../store";
import { SideType, TargetZoomType } from "../../../store/types/store";
import { getRoomDepthValueInMeters } from "../../../utils/getRoomDepthValue";

type RoomDimensions = { width: number; height: number; depth: number };

function getDistanceLimits(
    currentSide: SideType,
    targetZoom: TargetZoomType,
    dimensions: RoomDimensions
): { min: number; max: number } {
    const proMode = useStoreSystem.getState().proMode;
    const sr = useStoreRoom.getState();
    const distanceLimit = proMode
        ? useStoreRoom.getState().depth / 1000
        : (useStoreRoom.getState().cameraDistance > 0
              ? useStoreRoom.getState().cameraDistance
              : useStoreRoom.getState().depth) / 1000;

    if (targetZoom === "item") {
        return { min: 0.3, max: proMode ? 15 : distanceLimit };
    }
    if (currentSide === "top") {
        return { min: 3, max: 20 };
    }
    return { min: 1, max: proMode ? 20 : distanceLimit };
}

export default getDistanceLimits;
